import React from "react";

// Context
import { useFormSelectDialog } from "core/FormSelectDialog/context/useFormSelectDialog";

// components
import Dialog from "../../components/Dialog";
import IconEdit from "../../components/IconEdit";
import Control from "../../components/Control";

// component
export const Content = () => {
    const { isDisabled } = useFormSelectDialog();

    return (
        <>
            <Control>{!isDisabled && <IconEdit />}</Control>
            <Dialog />
        </>
    );
};

export default Content;
